import type { IconifyJSON } from '@iconify/types';
import { addCollection } from '@iconify/react/offline';

// Full icon sets bundled once — no runtime fetch (works with strict CSP; no /iconify proxy needed).
import akarIcons from '@iconify/json/json/akar-icons.json';
import carbon from '@iconify/json/json/carbon.json';
import circleFlags from '@iconify/json/json/circle-flags.json';
import eosIcons from '@iconify/json/json/eos-icons.json';
import eva from '@iconify/json/json/eva.json';
import faBrands from '@iconify/json/json/fa-brands.json';
import fluent from '@iconify/json/json/fluent.json';
import gameIcons from '@iconify/json/json/game-icons.json';
import gridicons from '@iconify/json/json/gridicons.json';
import ic from '@iconify/json/json/ic.json';
import iconamoon from '@iconify/json/json/iconamoon.json';
import logos from '@iconify/json/json/logos.json';
import materialSymbols from '@iconify/json/json/material-symbols.json';
import mdi from '@iconify/json/json/mdi.json';
import mingcute from '@iconify/json/json/mingcute.json';
import pepiconsPencil from '@iconify/json/json/pepicons-pencil.json';
import qlementineIcons from '@iconify/json/json/qlementine-icons.json';
import solar from '@iconify/json/json/solar.json';
import stash from '@iconify/json/json/stash.json';

const COLLECTIONS: IconifyJSON[] = [
  solar as IconifyJSON,
  eva as IconifyJSON,
  mingcute as IconifyJSON,
  mdi as IconifyJSON,
  ic as IconifyJSON,
  carbon as IconifyJSON,
  gridicons as IconifyJSON,
  fluent as IconifyJSON,
  iconamoon as IconifyJSON,
  logos as IconifyJSON,
  faBrands as IconifyJSON,
  gameIcons as IconifyJSON,
  eosIcons as IconifyJSON,
  akarIcons as IconifyJSON,
  materialSymbols as IconifyJSON,
  pepiconsPencil as IconifyJSON,
  qlementineIcons as IconifyJSON,
  stash as IconifyJSON,
  circleFlags as IconifyJSON,
];

export function registerIconifyOfflineCollections(): void {
  for (const data of COLLECTIONS) {
    addCollection(data);
  }
}

registerIconifyOfflineCollections();
